<sd-dialog [title]="title">
    <p class="text-base text-gray-700 mb-6">{{ message }}</p>
    
    <div class="flex gap-3 justify-end">
        <button (click)="matDialog.close(false)" class="cancel-button">
            {{ cancelText }}
        </button>
        <button (click)="matDialog.close(true)" class="confirm-button">
            {{ confirmText }}
        </button>
    </div>
</sd-dialog>
